<template>
  <b-modal
    v-model="getInternetStatus"
    title="Sem conexão com a Internet"
    hide-footer
    centered
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
  >
    <p class="text-center">Você está offline. Por favor, verifique sua conexão com a Rede.</p>
    <b-button variant="primary" class="mt-3" block @click="reloadPage"> Recarregar página </b-button>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      getInternetStatus: 'main/getInternetStatus',
    }),
  },
  methods: {
    reloadPage() {
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.text-center {
  text-align: center;
}
</style>
